export function convertExpiresInToExpiresAt(expiresIn) {
  if (expiresIn === null || expiresIn === undefined) {
    return null;
  }
  return Math.floor(Date.now() / 1000 + expiresIn);
}
//# sourceMappingURL=timestampConversion.js.map